module.exports = __webpack_public_path__ + "img/weight-c.e78c9bee.png";